global.businessTypeList = global.API_ADMIN_URL+'businessTypeList/';
global.adminAddBusinessType = global.API_ADMIN_URL+'adminAddBusinessType/';
global.adminEditBusinessType = global.API_ADMIN_URL+'adminEditBusinessType/';
global.businessTypeDetails = global.API_ADMIN_URL+'businessTypeDetails/';
global.businessTypeDelete = global.API_ADMIN_URL+'businessTypeDelete/';
global.businessTypeStatus = global.API_ADMIN_URL+'businessTypeStatus/';